/* eslint-disable react/no-unknown-property */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import { Table, Divider, Select, Option, Input, Spin, Tag, Form } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory, Link } from 'react-router-dom';
import DokanIcons from '../../../components/icon/DokanIcons';
import DokanPageTitle from '../../../components/text/DokanPageTitle';
import {
    setSingleOrder,
    fetchOrdersSummary,
    handleDetailsInput,
    updateOrderDetails,
} from '../../../redux/orders/ordersActions';
import loader from '../../../assets/images/loader.svg';
import LineItemsCard from '../../../components/orders/LineItemsCard';
import CustomerContact from '../../../components/orders/CustomerContact';
import Summary from '../../../components/orders/Summary';
import DownloadPermission from '../../../components/orders/DownloadPermission';
import OrderNotes from '../../../components/orders/OrderNotes';
import OrderTracking from '../../../components/orders/OrderTracking';
import DokanAlert from '../../../components/shared/Alert';
import { ISOToDMY } from '../../../utils/date';

const { TextArea } = Input;

/**
 * @param{props}
 * @returns {render}
 */
const OrderDetails = () => {
    const { orderId } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const loading = <img src={loader} alt={loader} className="h-16 w-16" />;

    useEffect(() => {
        dispatch(setSingleOrder(orderId));
    }, [dispatch, orderId]);

    // const singleOrderData = useSelector((state) => state.orders);
    const order_status = useSelector((state) => state.orders.orderStatus);
    const { detailsLoading, singleOrderDetails } = useSelector((state) => state.orders);
    const options = order_status.map((d) => (
        <Select.Option key={d.value} className="py-3">
            {d.name}
        </Select.Option>
    ));

    const handleChangeInput = (name, value = '', e = null) => {
        const inputObj = { name, value, e };
        dispatch(handleDetailsInput(inputObj));
    };

    const onFinish = (values) => {
        dispatch(updateOrderDetails(singleOrderDetails));
    };

    // console.log(singleOrderDetails);
    return (
        <>
            <div className="container mx-auto min-h-screen p-6 md:p-50px">
                <DokanAlert />
                <div className="flex justify-between">
                    <div className="w-2/4 flex items-center gap-3">
                        <div>
                            <DokanIcons icon="#back_to" size="3" />
                        </div>
                        <div className="text-tertiary">
                            <Link to="/orders">Back to Order List</Link>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col mt-3 gap-3">
                    <div>
                        <DokanPageTitle>Order#{singleOrderDetails?.number ?? ''}</DokanPageTitle>
                    </div>
                    <div>
                        <span className="font-medium text-md text-secondary">
                            {singleOrderDetails?.created_at ?? ''}
                        </span>
                    </div>
                    <div className="text-tertiary font-light">
                        Edited: {ISOToDMY(singleOrderDetails?.date_modified)}
                    </div>
                </div>
                <Spin spinning={detailsLoading}>
                    <Form onFinish={onFinish}>
                        <div className="flex justify-between items-center mt-3">
                            <Form.Item name="status">
                                <div className="w-40 rounded-md">
                                    <Select
                                        showArrow
                                        onChange={(value) => handleChangeInput('status', value)}
                                        value={singleOrderDetails.status}
                                    >
                                        {options}
                                    </Select>
                                </div>
                            </Form.Item>
                            <Form.Item>
                                <div className="bg-button-secondary rounded-sm">
                                    <button
                                        type="submit"
                                        className="px-4 py-2 text-white font-semibold focus:outline-none"
                                    >
                                        Update
                                    </button>
                                </div>
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 justify-between gap-5">
                            <Spin spinning={false}>
                                <div>
                                    <div className="flex flex-col">
                                        <LineItemsCard singleOrderData={singleOrderDetails} />
                                        <CustomerContact singleOrderData={singleOrderDetails} />
                                        <DownloadPermission />
                                    </div>
                                </div>
                            </Spin>
                            <div>
                                <div className="flex flex-col">
                                    <Summary singleOrderData={singleOrderDetails} />
                                    <OrderNotes
                                        OrderId={singleOrderDetails.id}
                                        orderStatus={singleOrderDetails.status}
                                    />
                                    <OrderTracking OrderId={singleOrderDetails.id} />
                                </div>
                            </div>
                        </div>
                    </Form>
                </Spin>
            </div>
        </>
    );
};

export default OrderDetails;
